(() => {
  const section = document.querySelector('[data-product-recommendations]');
  if (!section || !section.dataset.url || section.children.length) return;

  const load = async () => {
    try {
      const response = await fetch(section.dataset.url, { credentials: 'same-origin' });
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const incoming = html.querySelector('[data-product-recommendations]');
      if (incoming?.innerHTML.trim()) section.innerHTML = incoming.innerHTML;
    } catch (_) {}
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(load, { timeout: 1200 });
  } else {
    window.setTimeout(load, 250);
  }
})();
